<template>
    <div class="integration-form">
        <b-card>
            <h2 class="">{{ $t('room.edit_title') }}</h2>
            <b-form @submit.prevent="handleSubmit" @reset="resetForm" novalidate>
                <!-- for selecting service  -->
                <div class="mb-3 text-left">
                    <label class="mb-1" for="room_number">{{ $t('room.label_room_number') }}</label>
                    <b-form-input
                        id="room_number"
                        type="number"
                        v-model="formFields.room_number"
                        :class="formErrors.has('room_number') ? 'error-input' : ''"
                        @input="removeError('room_number')"
                        :placeholder="$t('room.placeholder_room_number')"></b-form-input>

                    <b-form-invalid-feedback
                        :state="!formErrors.has('room_number')">
                        {{ formErrors.first('room_number') }}
                    </b-form-invalid-feedback> <!-- Show error message -->
                </div>
                <div class="mb-3 text-left">
                    <label for="size_sqft" class="mb-1">
                        {{ $t('room.label_size_sqft') }}
                    </label>
                    <b-form-input
                        type="text"
                        :placeholder="$t('room.placeholder_size_sqft')" 
                        id="size_sqft"
                        v-model="formFields.size_sqft" :class="formErrors.has('size_sqft') ? 'error-input' : ''"
                        @input="removeError('size_sqft')"></b-form-input>

                    <b-form-invalid-feedback :state="!formErrors.has('size_sqft')">
                        {{ formErrors.first('size_sqft') }}
                    </b-form-invalid-feedback>
                </div>
                <div class="mb-3 text-left">
                    <label class="mb-1" for="floor">{{ $t('room.label_floor') }}</label>
                    <b-form-input
                        id="floor"
                        type="number"
                        v-model="formFields.floor"
                        :class="formErrors.has('floor') ? 'error-input' : ''"
                        :placeholder="$t('room.placeholder_floor')"
                        @input="removeError('floor')"></b-form-input>

                    <b-form-invalid-feedback :state="!formErrors.has('floor')">
                        {{ formErrors.first('floor') }}
                    </b-form-invalid-feedback> <!-- Show error message -->
                </div>
                <div class="mb-3 text-left">
                    <label class="mb-1" for="view">{{ $t('room.label_view') }}</label>
                    <b-form-input id="view" type="text" v-model="formFields.view"
                        :placeholder="$t('room.placeholder_view')"></b-form-input>

                    <b-form-invalid-feedback :state="!formErrors.has('view')">
                        {{ formErrors.first('view') }}
                    </b-form-invalid-feedback> <!-- Show error message -->
                </div>
                <div class="mb-3">
                    <b-form-checkbox :placeholder="$t('room.placeholder_accessibility_support')"
                        id="accessibility_support" value="1" v-model="formFields.accessibility_support"
                        :class="formErrors.has('accessibility_support') ? 'error-input' : ''"
                        @input="removeError('accessibility_support')" unchecked-value="0">
                        {{ $t('room.label_accessibility_support') }}
                    </b-form-checkbox>

                    <b-form-invalid-feedback :state="!formErrors.has('accessibility_support')">
                        {{ formErrors.first('accessibility_support') }}
                    </b-form-invalid-feedback>
                </div>
                <div class="mb-3 text-left">
                    <label for="notes" class="mb-1">
                        {{ $t('room.label_notes') }}
                    </label>
                    <b-form-textarea :placeholder="$t('room.placeholder_notes')" id="notes" v-model="formFields.notes"
                        :class="formErrors.has('notes') ? 'error-input' : ''"
                        @input="removeError('notes')"></b-form-textarea>

                    <b-form-invalid-feedback :state="!formErrors.has('notes')">
                        {{ formErrors.first('notes') }}
                    </b-form-invalid-feedback>
                </div>
                <div class="d-flex gap-2 mt-4">
                    <b-button type="submit" variant="primary" :disabled="loader">
                        <b-spinner small v-if="loader" class="mr-1"></b-spinner>
                        {{ $t('action.submit') }}
                    </b-button>
                    <b-button variant="secondary" @click="cancel">{{ $t('action.cancel') }}</b-button>
                </div>
            </b-form>
        </b-card>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import Error from "@/Util/Error";
import { mapGetters } from "vuex";
const FORM_STATE = {
    room_number: null,
    size_sqft: null,
    floor: null,
    view: null,
    accessibility_support: false,
    notes: null,
};
export default {
    name: 'RoomForm',
    components: {
    },
    data() {
        return {
            id: null,
            formFields: { ...FORM_STATE },
            formErrors: new Error({}),
        };
    },
    mounted() {
        this.id = this.$route.params.room_id || null;
        this.room_type_id = this.$route.params.id || null;
        if (this.room_type_id && this.id) {
            this.fetchRoom();
        }
    },
    methods: {
        async fetchRoom() {
            try {
                const response = await request({ method: 'get', url: `/rooms/${this.id}` });
                this.formFields = {
                    room_number: response.data.room_number,
                    size_sqft: response.data.size_sqft,
                    floor: response.data.floor,
                    view: response.data.view,
                    accessibility_support: response.data.accessibility_support,
                    notes: response.data.notes
                };
            } catch (error) {
                console.error('Failed to load Rooms', error);
            }
        },
        normalizer(node) {
            return {
                id: node.id,
                label: node.name + ', ' + node.bed_type
            };
        },
        resetError() {
            this.formErrors = new Error({});
        },
        async removeError(key) {
            console.log(key);
            
            if (typeof key === 'object') {
                for (let i = 0; i < key.length; i++) {
                    this.formErrors.remove(key[i]);
                }
            } else {
                this.formErrors.remove(key);
            }
        },
        async handleSubmit() {
            try {
                this.formErrors = new Error({});
                const payload = {...this.formFields,room_type_id:this.room_type_id};
                await request({
                    method: 'PUT',
                    url: `/rooms/${this.id}`,
                    data: payload
                });
                const successMessage = this.$t("room.updated_successfully");
                this.notifySuccessWithMsg(successMessage);
                setTimeout(() => {
                    this.formFields = { ...FORM_STATE };
                    this.$router.push({ name: 'RoomTypeRooms', params: { id: this.$route.params.id } });
                }, 500);
            } catch (error) {
                if (error.request && error.request.status && error.request.status === 422) {
                    this.formErrors = new Error(JSON.parse(error.request.responseText).errors);
                    return false;
                } else {
                    this.notifyError();
                }
            }
        },
        cancel() {
            this.$router.back();
        },
        resetForm() {
            this.formFields = { ...FORM_STATE };
            this.formErrors = new Error({});
        },
    },
    computed: {
        ...mapGetters(['loader'])
    }
};
</script>

<style scoped>
.integration-form {
    padding: 20px;
}

.form-group {
    margin-bottom: 20px;
}

h2 {
    margin-bottom: 1.5rem;
    color: #2c3e50;
    font-size: 2rem;
}

.error-input {
    border-color: #dc3545 !important;
}
</style>
